<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑销售订单' : '添加销售订单'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <div class="st-form-title">基本信息</div>
        <div class="st-form-group">

          <van-cell-group inset>
            <st-form-item key="clientid" label="选择客户" prop="clientid" :required="true">
              <st-select
                v-model="formData.clientid"
								:defText="formData.clientName"
                name="客户"
                placeholder="请选择客户"
                :options="options['customer']"
								@change="customerChange"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="settlementtype" label="结算方式" prop="settlementtype" disabled>
              <st-select
                v-model="formData.settlementtype"
                name="结算方式"
                placeholder="请选择结算方式"
                :options="options['settlementtype']"
                :readonly="true"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="amount_subsist" label="预付款金额" prop="amount_subsist" :required="true" v-if="formData.settlementtype == 2">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.amount_subsist"
						    name="预付款金额"
						    label=""
						    placeholder="请填写预付款金额"
						  />
						</st-form-item>
						
						<st-form-item key="resttime" label="尾款付款时间" prop="resttime" :required="true">
							<st-date
								v-model="formData.resttime"
								name="尾款付款时间"
								placeholder="请选择尾款付款时间"
							></st-date>
						</st-form-item>

            <st-form-item key="company_id" label="选择销售单位" prop="company_id" :required="true">
              <st-select
                v-model="formData.company_id"
                name="选择销售单位"
                placeholder="请选择销售单位"
                :options="options['companyList']"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="corporation_id" label="选择收款账户" prop="corporation_id" :required="true">
              <st-select
                v-model="formData.corporation_id"
                name="收款账户"
                placeholder="请选择收款账户"
                :options="options['corporation']"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="seller" label="选择销售员" prop="seller" :required="true">
              <st-select
                v-model="formData.seller"
                name="销售员"
                placeholder="请选择销售员"
                :options="options['userList']"
              >
              </st-select>
            </st-form-item>

						
						<st-form-item key="deliverytime" label="客需发货时间" prop="deliverytime" :required="true">
							<st-date
								v-model="formData.deliverytime"
								name="客需发货时间"
								placeholder="请选择客需发货时间"
							></st-date>
						</st-form-item>
            
            <st-form-item key="shippingmethods" label="物流方式" prop="shippingmethods" :required="true">
              <st-select
                v-model="formData.shippingmethods"
                name="物流方式"
                placeholder="请选择物流方式"
                :options="options['shippingmethods']"
                :readonly="true"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="paytype" label="付款方式" prop="paytype" :required="true">
              <st-select
                v-model="formData.paytype"
                name="付款方式"
                placeholder="请选择付款方式"
                :options="options['paytype']"
                :readonly="true"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="currency" label="币种" prop="currency" :required="true">
              <st-select
                v-model="formData.currency"
                name="币种"
                placeholder="请选择币种"
                :options="options['currency']"
								ref="currency-select"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="exchange_rate" label="汇率" prop="exchange_rate" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData.exchange_rate"
                name="汇率"
                label=""
                placeholder="请输入汇率"
              />
            </st-form-item>
						
						<st-form-item key="tax_rate" label="税率" prop="tax_rate" :required="true">
						  <st-select
						    v-model="formData.tax_rate"
						    name="税率"
						    placeholder="请选择税率"
						    :options="options['tax_rates']"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="deliveryplace" label="交货地点" prop="deliveryplace" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.deliveryplace"
						    name="交货地点"
						    label=""
						    placeholder="请填写交货地点"
						    type="textarea"
						  />
						</st-form-item>
            
            <st-form-item key="attn" label="Tel&Attn" prop="attn" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData.attn"
                name="Tel&Attn"
                label=""
                placeholder="请填写Tel&Attn"
              />
            </st-form-item>
						
            <st-form-item key="Payment" label="Payment" prop="payment">
              <van-field
                class="st-form-item-input"
                v-model="formData.payment"
                name="Payment"
                label=""
                placeholder="请填写Payment"
              />
            </st-form-item>

            <st-form-item key="add" label="Add" prop="add">
              <van-field
                class="st-form-item-input"
                v-model="formData.add"
                name="Add"
                label=""
                placeholder="请填写Add"
                type="textarea"
              />
            </st-form-item>

            <st-form-item key="collection_summary" label="收款摘要" prop="collection_summary">
              <van-field
                class="st-form-item-input"
                v-model="formData.collection_summary"
                name="收款摘要"
                label=""
                placeholder="请填写收款摘要"
                type="textarea"
              />
            </st-form-item>

            <st-form-item key="remark" label="备注" prop="remark">
              <van-field
                class="st-form-item-input"
                v-model="formData.remark"
                name="备注"
                label=""
                placeholder="请填写备注"
                type="textarea"
              />
            </st-form-item> 

            <st-form-item key="enclosure" label="销售合同" prop="enclosure">
              <st-file-upload
                v-model="formData['enclosure']"
              >
              </st-file-upload>
            </st-form-item>

            <st-form-item key="fujian" label="附件" prop="fujian">
              <st-file-upload
                v-model="formData['fujian']"
              >
              </st-file-upload>
            </st-form-item>
          </van-cell-group>
        </div>
        
        <div class="st-form-title">
          <span>产品信息</span>
          <van-button class="st-van-btn-info" @click="newItem">新增产品</van-button>
        </div>

        <div class="st-form-group">
          <van-cell-group inset>
            <div class="product-item" v-for="(v, k) in formData['items']" :key="k">
              <div class="prudcut-del-box" v-if="formData['items'].length > 1" @click="delItem(k)"><i class="el-icon-close"></i></div>
              <h3 style="text-align: center;">产品{{ k + 1 }}</h3>

              <st-form-item :key="`items.${k}.products_id`" label="SKU" :prop="`items.${k}.products_id`" :required="true">
                <st-select
                  v-model="formData['items'][k]['products_id']"
                  name="SKU"
                  placeholder="请选择SKU"
                  :options="options['sku']"
									:defText="formData['items'][k]['name']"
                >
                </st-select>
              </st-form-item>

            <st-form-item :key="`items.${k}.products_name`" label="产品描述" :prop="`items.${k}.products_name`">
              <van-field
                class="st-form-item-input"
                v-model="formData['items'][k]['products_name']"
                name="产品描述"
                label=""
                placeholder="请输入产品描述"
              />
            </st-form-item>

            <st-form-item :key="`items.${k}.total`" label="销售数量" :prop="`items.${k}.total`" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData['items'][k]['total']"
                name="采购数量"
                label=""
                placeholder="请输入采购总量"
              />
            </st-form-item>

            <st-form-item :key="`items.${k}.price`" label="销售单价" :prop="`items.${k}.price`" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData['items'][k]['price']"
                name="采购单价"
                label=""
                placeholder="请输入采购单价"
              />
            </st-form-item>

            <st-form-item :key="`items.${k}.unit`" label="单位" :prop="`items.${k}.unit`">
              <van-field
                class="st-form-item-input"
                v-model="formData['items'][k]['unit']"
                name="单位"
                label=""
                placeholder="请输入单位"
              />
            </st-form-item>

            <st-form-item :key="`items.${k}.remarks`" label="备注" :prop="`items.${k}.remarks`">
              <van-field
                class="st-form-item-input"
                v-model="formData['items'][k]['remarks']"
                name="备注"
                label=""
                placeholder="请输入备注"
                type="textarea"
              />
            </st-form-item>
            </div>
            
          </van-cell-group>
          <div style="margin: 16px;" class="new-pruduct-btn-box">
            <button class="new-pruduct-btn" @click="newItem">
              <i class="el-icon-plus"></i>
            </button>
          </div>
        </div>

        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
      <div class="static">
        <div style="color: rgba(255, 255, 255, 1);font-weight: 900;">合计金额</div>
        <div style="color: rgba(255, 195, 0, 1);font-size: 16px;font-weight: 900;">{{ sku_amount }} </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import { getCurrency, getCustomer, settlementtype, getCompanyList, option_is_overseas, getCorporation, getUserList,
 shippingmethods, paytype, getPurchaseSku, tax_rates } from "@/views/Sto/sale/conf/options";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import formConf from "./conf/form.js";

export default {
  name: 'stSalesAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
        items: [{}],
				currency: 'CNY',
				exchange_rate: 1,
				tax_rate: '13',
				shippingmethods: '0',
				isinvoice: 1,
				amount: 0,
				settlementtype: '',
				amount_subsist: '',
				resttime: '',
      }, 
      loading: false,
      actField: '',
      actOptions: [],
      options: {
        is_overseas: option_is_overseas,
        currency: getCurrency,
        customer: getCustomer,
        settlementtype,
        companyList: getCompanyList,
        corporation: getCorporation,
        userList: getUserList,
        shippingmethods,
        paytype,
				sku: getPurchaseSku,
				tax_rates,
      },
			conf: formConf,
    };
  },
  watch: {},
	computed: {
		sku_amount: function() {
			this.formData.amount = this.formData.items.reduce((acc, obj) => acc + ((obj.price * obj.total) ? obj.price * obj.total : 0), 0);
			return this.formData.amount + " " + this.formData.currency;
		}
	},
  created() {
		this.mode = this.$route.query.mode;
		if (!['0', '2'].includes(this.mode)) {
			this.$toast.fail('参数错误');
			// this.$router.replace('/');
		}
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			this.formData.id = this.$route.params['id'];
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stSaleUpdate}/sid/${this.formData.id}`, {}).then((res) => {
					let data = res.data;
					let paytypeOp = this.options.paytype.find((v) => { return v.text == data.paytype });
					data.paytype = paytypeOp ? paytypeOp['value'] : '';
					let settletypeOp = this.options.settlementtype.find((v) => { return v.text == data.settlementtype });
					data.settlementtype = settletypeOp['value'];
					this.formDataText
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('sales/add', err);
				});
			}
		},
		// 选择了客户  会有对应的结算方式
		customerChange(val) {
			this.$post(this.$api.stCustomerInfo, { id: val }).then((res) => {
				let settle = (settle = this.conf.customerPayment2settle[res.data['payment_days']]) 
					? settle : this.conf.customerPayment2settle['default'];
				this.formData.settlementtype = settle.val;
				this.formData.amount_subsist = '';
				this.formDataText.resttimeText = '';
			}).catch((e) => {
				console.log('sales/add', e);
			});
		},
		
    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData['enclosure'] = formData['enclosure'].map((item) => { return item.url; }).join(',');
      formData['fujian'] = formData['fujian'].map((item) => { return item.url; }).join(',');
			formData['type'] = this.mode;
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.stSaleAdd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建销售订单成功");
			    this.$router.replace(`/sale/list/${this.mode}/0`);
			  }
			});
		},
		updateData(formData) {
			// 筛选一下 要提交的字段
			for(let field in formData) {
				if (!this.conf.updateAllowField.includes(field)) {
					formData[field] = undefined;
				}
			}
			this.$post(this.$api.stSaleUpdate, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑销售订单成功");
			    this.$router.replace(`/sale/list/${this.mode}/0`);
			  }
			});
		},

    // 创建一个产品
    newItem() {
      this.formData.items.push({});
    },

    // 删除一个产品
    delItem(index) {
      this.formData.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;

  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

    .product-item {
      background-color: rgba(230, 236, 241, 1);
      padding: 15px;
      margin-top: 18px;

      .prudcut-del-box {
        margin-top: -10px;
        float: right;
        text-align: right;
        font-size: 31px;
        color: rgba(227, 60, 100, 1);
      }
    }

    .new-pruduct-btn {
      width: 317px;
      height: 44px;
      border-radius: 5px;
      color: rgba(80, 80, 80, 1);
      background: rgba(42, 130, 228, 1);
      line-height: 150%;
      border: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;

      .el-icon-plus {
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-weight: bolder;
      }
    }
  }

  .static {
    display: flex;
    justify-content: space-around;
    height: 70px;
    background-color: rgba(56, 56, 56, 1);
    font-size: 14px;
    line-height: 150%;
    align-items: center;

    div {
      text-align: center;
    }

    border-radius: 0px,0px,5px,5px;
  }
}

</style>
